import { useCallback } from 'react';
import { useState } from 'react';

interface UseIsActiveState {
    onFocus: () => void;
    onBlur: () => void;
    onMenuOpen: () => void;
    onMenuClose: () => void;
    isActive: boolean;
    isMenuOpen: boolean;
    isFocused: boolean;
}

const useIsActiveState = (): UseIsActiveState => {
    const [isActive, setActive] = useState(false);
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isFocused, setFocused] = useState(false);

    const handleFocus = useCallback(() => {
        setActive(true);
        setFocused(true);
    }, []);

    const handleBlur = useCallback(() => {
        setActive(false);
        setFocused(false);
    }, []);

    const handleMenuOpen = useCallback(() => {
        setActive(true);
        setMenuOpen(true);
    }, []);

    const handleMenuClose = useCallback(() => {
        setActive(false);
        setMenuOpen(false);
    }, []);

    return {
        onFocus: handleFocus,
        onBlur: handleBlur,
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        isActive,
        isMenuOpen,
        isFocused,
    };
};

export default useIsActiveState;
